import { clsx } from 'clsx'

type Props = {
  placeholder?: string
  type?: 'text' | 'email' | 'password' | 'date' | 'number'
  className?: string
  name?: string
  ariaLabel?: string
  dataTestId?: string
  value?: string
  min?: string | number
  max?: string | number
  autoFocus?: boolean
  autoComplete?: string
  disabled?: boolean
  onChange?: (value: string) => void
  onBlur?: () => void
}
export function TextInput({
  className,
  autoFocus,
  autoComplete,
  placeholder,
  name,
  ariaLabel,
  dataTestId,
  value,
  min,
  max,
  disabled,
  onChange,
  type = 'text',
  onBlur
}: Props) {
  return (
    <input
      type={type}
      name={name}
      aria-label={ariaLabel}
      data-testid={dataTestId}
      autoFocus={autoFocus}
      autoComplete={autoComplete}
      disabled={disabled}
      min={min}
      max={max}
      placeholder={placeholder}
      className={clsx(
        'rounded-md border-0 text-base text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:leading-6 [:where(&)]:py-1.5',
        className
      )}
      value={value}
      onChange={(e) => onChange?.(e.target.value)}
      onBlur={onBlur}
    />
  )
}
